import React from "react";

const WIDTHS = ["w-1/4", "w-1/3", "w-1/2", "w-2/5", "w-3/5", "w-1/3", "w-2/3", "w-1/4"];

const SkeletonRows = ({ columnCount, rowCount = 8, selectable = false, hasRowAction = false }) => {
    const totalCols = columnCount + (selectable ? 1 : 0) + (hasRowAction ? 1 : 0);

    return Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr key={rowIndex} className={rowIndex % 2 !== 0 ? "bg-ink-50" : "bg-white"}>
            {Array.from({ length: totalCols }).map((_, colIndex) => (
                <td key={colIndex} className="px-6 py-3">
                    <div
                        className={`h-3.5 animate-pulse rounded-full bg-ink-200 ${
                            WIDTHS[(rowIndex + colIndex) % WIDTHS.length]
                        }`}
                    />
                </td>
            ))}
        </tr>
    ));
};

export default SkeletonRows;
